(function() {
  const BAR_STORAGE_KEY = 'makers_rebrand_bar_dismissed_until';
  const POPUP_STORAGE_KEY = 'makers_rebrand_popup_seen';
  const BAR_DISMISS_MS = 7 * 24 * 60 * 60 * 1000;

  function shouldRunOnCurrentSite() {
    const host = window.location.hostname;
    const isLocalPreview = host === '127.0.0.1' || host === 'localhost';
    if (!isLocalPreview) {
      return host === 'makersartstudio.com' || host === 'www.makersartstudio.com';
    }
    const site = new URLSearchParams(window.location.search).get('site');
    return site === 'brand';
  }

  function parseLaunchDate(value) {
    if (!value || typeof value !== 'string') return null;
    const trimmed = value.trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return null;
    const date = new Date(`${trimmed}T00:00:00`);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  function isActiveWindow(enabled, launchDateString, displayDays) {
    if (enabled !== 'true') return false;
    const launchDate = parseLaunchDate(launchDateString);
    if (!launchDate) return false;
    const activeDays = Number.parseInt(displayDays, 10);
    if (!Number.isFinite(activeDays) || activeDays < 1) return false;

    const now = new Date();
    const launchStart = launchDate.getTime();
    const launchEnd = launchStart + activeDays * 24 * 60 * 60 * 1000;

    return now.getTime() >= launchStart && now.getTime() < launchEnd;
  }

  function getStoredTimestamp(key) {
    try {
      return Number.parseInt(window.localStorage.getItem(key) || '', 10);
    } catch (error) {
      return NaN;
    }
  }

  function setStorageValue(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // no-op
    }
  }

  function initAnnouncementBar() {
    const bar = document.querySelector('[data-rebrand-announcement]');
    if (!bar) return;
    if (!shouldRunOnCurrentSite()) return;

    const active = isActiveWindow(bar.dataset.enabled, bar.dataset.launchDate, bar.dataset.displayDays);
    if (!active) return;

    const dismissedUntil = getStoredTimestamp(BAR_STORAGE_KEY);
    if (Number.isFinite(dismissedUntil) && Date.now() < dismissedUntil) return;

    bar.hidden = false;
    const closeButton = bar.querySelector('[data-rebrand-bar-close]');
    if (!closeButton) return;

    closeButton.addEventListener('click', function() {
      setStorageValue(BAR_STORAGE_KEY, String(Date.now() + BAR_DISMISS_MS));
      bar.hidden = true;
    });
  }

  function initPopup() {
    const popup = document.querySelector('[data-rebrand-popup]');
    if (!popup) return;
    if (!shouldRunOnCurrentSite()) return;

    const active = isActiveWindow(popup.dataset.enabled, popup.dataset.launchDate, popup.dataset.displayDays);
    if (!active) return;

    let seen = false;
    try {
      seen = window.localStorage.getItem(POPUP_STORAGE_KEY) === 'true';
    } catch (error) {
      seen = false;
    }
    if (seen) return;

    const dialog = popup.querySelector('[role="dialog"]');
    const closeButton = popup.querySelector('[data-rebrand-popup-close]');
    const backdrop = popup.querySelector('[data-rebrand-popup-backdrop]');
    const actionLinks = Array.from(popup.querySelectorAll('[data-rebrand-popup-action]'));
    if (!dialog || !closeButton) return;

    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'textarea:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    let previousActiveElement = null;

    function markSeen() {
      setStorageValue(POPUP_STORAGE_KEY, 'true');
    }

    function closePopup(markAsSeen) {
      if (popup.hidden) return;
      if (markAsSeen) markSeen();
      popup.hidden = true;
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('keydown', handleKeydown);
      if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
        previousActiveElement.focus();
      }
    }

    function trapFocus(event) {
      if (event.key !== 'Tab') return;
      const focusableElements = Array.from(dialog.querySelectorAll(focusableSelector))
        .filter((element) => !element.hasAttribute('disabled') && element.offsetParent !== null);
      if (!focusableElements.length) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }

    function handleKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup(true);
        return;
      }
      trapFocus(event);
    }

    function openPopup() {
      previousActiveElement = document.activeElement;
      popup.hidden = false;
      document.body.classList.add('overflow-hidden');
      document.addEventListener('keydown', handleKeydown);
      window.requestAnimationFrame(function() {
        closeButton.focus();
      });
    }

    closeButton.addEventListener('click', function() {
      closePopup(true);
    });

    if (backdrop) {
      backdrop.addEventListener('click', function() {
        closePopup(true);
      });
    }

    actionLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        markSeen();
      });
    });

    const delay = Number.parseInt(popup.dataset.popupDelay || '1800', 10);
    window.setTimeout(openPopup, Number.isFinite(delay) ? delay : 1800);
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAnnouncementBar();
    initPopup();
  });
})();
